import React, { useEffect, useRef, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { keyframes } from '@emotion/react';
import { useSelector } from 'react-redux';


const ScrollingTextList = ({ texts }) => {

  const { data } = useSelector((store) => (store.notification))
  let [scroll, setScroll] = useState(null);
  let [time, setTime] = useState(null);
  // const data = [
  //   {
  //     desc: `<p>这是一条测试通知</p>`
  //   },
  //   {
  //     desc: `<p>这是一条测试通知</p>`
  //   },
  //   {
  //     desc: `<p>这是一条测试通知</p>`
  //   },
  //   {
  //     desc: `<p>这是一条测试通知</p>`
  //   }
  // ]
  const containerRef = useRef(null);
  useEffect(() => {
    // 计算每个文本元素的宽度，并根据文本长度动态调整动画速度
    const adjustAnimation = () => {
      if (containerRef.current) {
        setTimeout(()=>{
          const containerWidth = containerRef.current.offsetWidth;
          const textWidth = containerRef.current.scrollWidth;
  
          // 计算位移距离，确保文本完全显示
          const translateDistance = textWidth + containerWidth + 50; // 加上额外的距离，确保文本能完全显示
          // containerRef.current.style.animation = `${scroll} 10s linear infinite`;
          // containerRef.current.style.transform = `translateX(-${translateDistance}px)`;
          console.log(translateDistance)
          setTime(translateDistance / 50 + 's');
          setScroll(keyframes`
          0% {
            transform: translateX(100%);
          }
          100% {
            transform: translateX(-${translateDistance}px);
          }
           `)
            ;
        },1500)
        
      }
    };
    adjustAnimation();

    window.addEventListener('resize', adjustAnimation);

    return () => {
      window.removeEventListener('resize', adjustAnimation);
    };
  }, []);

  return (
    <Box
      ref={containerRef}

      sx={{
        width: '85%',  // Adjust the width as needed
        overflow: 'hidden',
        position: 'absolute',
        whiteSpace: 'nowrap',
        zIndex: 9,
        left: '7.5%',
        top: '70px',
        height: '20px',
        padding: '1px',
        backgroundColor: "rgba(255,255,255,0.5)",
        borderRadius: '10px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: "center",
          height: '100%',
          lineHeight: '20px',
          animation: `${scroll} ${time} linear infinite`,
        }}
      >
        {data.map((item, index) => (
          item.stype == 2 && <Typography style={{ fontSize: '14px', lineHeight: '20px' }} key={index} component="span" sx={{ padding: '0 50px', display: 'inline-block' }} dangerouslySetInnerHTML={{ __html: item.desc }}>
          </Typography>
        ))}
        {/* {data.map((item, index) => (
          <Typography style={{ fontSize: '14px', lineHeight: '20px' }} key={index + data.length} component="span" sx={{ padding: '0 50px', display: 'inline-block' }} dangerouslySetInnerHTML={{ __html: item.desc }}>

          </Typography>
        ))} */}
      </Box>
    </Box>
  );
};

export default ScrollingTextList;
